module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch00_fm09_toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('strong', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm06_fore#ch00_fm06_fore",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm07_ack#ch00_fm07_ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm08_preface#ch00_fm08_preface",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They Rode Straight Up to Death: A Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01#part01"
    }
  }, [_vm._v("I. Texas: A Conflict of Civilizations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part02#part02"
    }
  }, [_vm._v("II. Out of the Revolution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03#part03"
    }
  }, [_vm._v("III. The Rangers and the Republic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part04#part04"
    }
  }, [_vm._v("IV. From Cherokee to Comanche")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part05#part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. The Captain Comes: John C. Hays")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part06#part06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. The Texas Rangers in the Mexican War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part07#part07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII. First Years in the Union")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part08#part08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII. The Bloody Years, 1858–1859")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part09#part09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX. The Cortinas War on the Rio Grande")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part10#part10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" X. Sam Houston’s Grand Plan.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part11#part11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI. The State Police")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part12#part12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII. McNelly and His Men in Southwest Texas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part13#part13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII. McNelly and the War of Las Cuevas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part14#part14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV. McNelly’s Successors: Lee Hall and John Armstrong")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part15#part15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV. The Frontier Battalion: Major John B. Jones.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part16#part16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI. The El Paso Salt War.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part17#part17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII. Sam Bass: Texas’s Beloved Bandit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part18#part18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVIII. The End of the Indian Trail: The Rangers in the Far West")])]), _vm._v(" "), _c('p', {
    staticClass: "toc6"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part19#part19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIX. The Closed Frontier: Last Services of the Frontier Battalion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part20#part20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XX. The Texas Rangers in the Twentieth Century")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part21#part21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXI. Revolution, World War, and Prohibition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part22#part22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXII. Frank Hamer: Modern Texas Ranger.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part23#part23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIII. Some Adventures of a Ranger Historian.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part23_ch02_biblio#part23_ch02_biblio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part23_ch03_index#part23_ch03_index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e913305","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm09_toc.vue
// module id = 84
// module chunks = 0